import OutreachContactSidebar from "./OutreachContactSidebar.vue";

export default OutreachContactSidebar;
